import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Loader from 'Loader/loader';
const Home = lazy(() => import('pages/Home/index'));
const Team = lazy(() => import('pages/Staff/Main'));
const Contact = lazy(() => import('pages/Contact/index'));
const About = lazy(() => import('pages/About/index'));
const Services= lazy(() => import('pages/Services/index'));
const PickColors= lazy(() => import('pages/Pick-Colors/Main'));
const Blog = lazy(() => import( 'pages/Blog'));
const NF404 = lazy(() => import( 'pages/404/404'));
const Gallery = lazy(()=>import('pages/Gallery/index'))
function App() {
  return (
    <BrowserRouter>
    <Suspense
          fallback={
            <><Loader/></>
          }
        >
      <Switch>
         <Route exact path='/' component={Home}/>
         <Route exact path='/contact-us' component={Contact}/>
         <Route exact path='/about-us' component={About}/>
         <Route exact path='/gallery' component={Gallery}/>
         <Route exact path='/staff' component={Team}/>
         <Route exact path='/products' component={Services}/>
         <Route exact path='/colours' component={PickColors}/>
         <Route exact path='/blog' component={Blog}/>
         <Route path="*" component={NF404}/>
      </Switch>
      </Suspense>
      {/* <div class="elfsight-app-444c45cc-63e9-4e31-9e74-77eb442741d1"></div> */}
    </BrowserRouter>
  );
}

export default App;
